const getStaticFileCdnUrl = (baseUrl: string) => (filePath: string) => {
  if (!filePath.startsWith("/")) {
    throw new Error("File path must start with a forward slash (/)");
  }

  return `${baseUrl}${filePath}`;
}

export const cdn = {
  static: getStaticFileCdnUrl(site.staticFilesCdn),
}